import {
  ADD_USER,
  SET_IN_CALL_STATUS,
  SET_IN_ADMIN_CALL_STATUS,
  SET_ACTIVE_LEAD,
  SET_APPLOADING,
  SET_CURRENT_TASK,
  SET_CALL_CONNECTED,
  SET_TASK_ATTRIBUTES,
  SET_RINGING,
  RESET_STATE,
  SET_APPLOADING_ERROR,
  UPDATE_APP_CONFIG,
  SET_USER_ACCESS
} from "./types/mutations";
import { vuexfireMutations } from "vuexfire";
import { User } from "@/types";
import defaultState from "./defaultState";

export default {
  ...vuexfireMutations,
  [RESET_STATE](state: any) {
    Object.assign(state, defaultState());
  },
  [SET_IN_CALL_STATUS](state: any, status: boolean) {
    state.inCallMode = status;
  },
  [SET_IN_ADMIN_CALL_STATUS](state: any, status: boolean) {
    state.inAdminCallMode = status;
  },
  [ADD_USER](state: any, user: User) {
    state.user = user;
  },
  [SET_ACTIVE_LEAD](state: any, lead: any) {
    state.activeLead = lead;
  },
  [SET_APPLOADING](state: any, status: boolean) {
    state.appLoading = status;
  },
  [SET_APPLOADING_ERROR](state: any, status: boolean) {
    state.appLoadingError = status;
  },
  [UPDATE_APP_CONFIG](state: any, config: any) {
    state.config = config;
  },
  [SET_CURRENT_TASK](state: any, task: any) {
    state.currentTask = task;
  },
  [SET_CALL_CONNECTED](state: any, status: boolean) {
    state.callConnected = status;
  },
  [SET_TASK_ATTRIBUTES](state: any, attributes: any) {
    state.taskAttributes = attributes;
  },
  [SET_RINGING](state: any, status: boolean) {
    state.ringing = status;
  },
  [SET_USER_ACCESS](state: any, access: any) {
    state.access = access;
  }
};
